import { createContext } from 'react';

export type INotificationBaseData = Partial<{
	options: NotificationOptions;
	title: string;
}>;
export type INotificationDataEvent<
	T extends INotificationBaseData = INotificationBaseData
> = {
	type: string;
	payload?: T;
};

export type INotificationContextState = {
	permission?: NotificationPermission | PermissionState;
	sendNotification: <T extends INotificationBaseData>(
		event: INotificationDataEvent<T>
	) => void;
};

export const notificationContext = createContext<INotificationContextState>({
	sendNotification: () => {},
});
